<template>

  <svg id="vtBuysSvg" data-name="Layer 1" stroke="currentColor"  xmlns="http://www.w3.org/2000/svg" width="100px" viewBox="0 0 367.15 272.17">
    <path stroke="currentColor" class="vtbuys-cls-2"
      d="M59.4,10.17c11.84.5,30.39-2.14,36.6,8.72,1.61,2.81,2.35,5.52,3.28,8.81,8.43,33.13,25.88,102.77,33.35,132.27,1,3.96,1.15,5.78,2.61,9.19,1.42,3.33,2.69,4.92,4.25,5.96,2.07,1.38,4.24,1.52,5.22,1.55,32.98.92,73.92.08,108.76.36,18.24-.09,35.68.2,53.48-.14,8.47-.05,12.08-3.34,14.94-10.54,2.63-6.33,4.67-12.64,7.07-19.53,2.76-7.94,7.95-28.73,27.47-79.85" />
    <circle stroke="currentColor" class="vtbuys-cls-1" cx="166.91" cy="239.2" r="23.08" />
    <circle stroke="currentColor" class="vtbuys-cls-1" cx="280.63" cy="239.2" r="23.08" transform="translate(-.43 477.89) rotate(-80.78)" />
    <path stroke="currentColor"  class="vtbuys-cls-1"
      d="M143.83,232.06c-12.08-.7-22.65-6.63-27.03-15.94-2.99-6.35-2.53-13.05-2.29-15.3.24-2.29,1-8.68,5.36-14.29,8.37-10.77,23.28-9.96,24.85-9.86" />
    <line stroke="currentColor" class="vtbuys-cls-1" x1="189.98" y1="229.1" x2="259.88" y2="229.1" />
    <line stroke="currentColor" class="vtbuys-cls-3" x1="37.51" y1="59.28" x2="84.26" y2="59.28" />
    <line  stroke="currentColor" class="vtbuys-cls-3" x1="8.52" y1="88.87" x2="60.88" y2="88.87" />
    <line stroke="currentColor" class="vtbuys-cls-3" x1="34.7" y1="114.9" x2="94.91" y2="114.9" />
    <g>
      <path stroke="currentColor" class="vtbuys-cls-4"
        d="M135.07,35.18h32.46c.72,0,1.29.36,1.5,1.14l13.23,49.48,4.58,17.02,4.43-17.23,12.73-49.27c.14-.79.72-1.14,1.43-1.14h28.46c.93,0,1.43.57,1.14,1.5l-28.96,97.53c-.29.72-.79,1.07-1.5,1.07h-39.04c-.71,0-1.22-.36-1.5-1.07l-30.03-97.53c-.29-.93.14-1.5,1.07-1.5Z" />
      <path stroke="currentColor" class="vtbuys-cls-4"
        d="M270.85,133.93l.86-49.27-.43-27.31h-26.24c-.86,0-1.36-.5-1.36-1.36v-19.52c0-.79.5-1.29,1.36-1.29h84.45c.79,0,1.29.5,1.29,1.29v19.52c0,.86-.5,1.36-1.29,1.36h-26.31l-.43,27.31.86,49.27c0,.93-.5,1.36-1.29,1.36h-30.1c-.86,0-1.36-.43-1.36-1.36Z" />
    </g>
  </svg>
</template>
<style>
      .vtbuys-cls-1, .vtbuys-cls-2 {
        stroke-width: 15px;
      }

      .vtbuys-cls-1, .vtbuys-cls-2, .vtbuys-cls-3 {
        fill: none;
        stroke-miterlimit: 10;
      }

      .vtbuys-cls-1, .vtbuys-cls-2, .vtbuys-cls-3, .vtbuys-cls-4 {
      }

      .vtbuys-cls-2, .vtbuys-cls-3 {
        stroke-linecap: round;
      }

      .vtbuys-cls-3 {
        stroke-width: 10px;
      }

      .vtbuys-cls-4 {
        fill: #183319;
      }
</style>

<script>
export default {
  name: 'ahsCirLogo',
}
</script>
